import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V18C21 18.7957 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7957 21 18 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6C3 5.20435 3.31607 4.44129 3.87868 3.87868ZM15 5H9V14.382L11.5528 13.1056C11.8343 12.9648 12.1657 12.9648 12.4472 13.1056L15 14.382V5ZM7 5H6C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V18C5 18.2652 5.10536 18.5196 5.29289 18.7071C5.48043 18.8946 5.73478 19 6 19H18C18.2652 19 18.5196 18.8946 18.7071 18.7071C18.8946 18.5196 19 18.2652 19 18V6C19 5.73478 18.8946 5.48043 18.7071 5.29289C18.5196 5.10536 18.2652 5 18 5H17V16C17 16.3466 16.8205 16.6684 16.5257 16.8507C16.2309 17.0329 15.8628 17.0494 15.5528 16.8944L12 15.118L8.44721 16.8944C8.13723 17.0494 7.76909 17.0329 7.47427 16.8507C7.17945 16.6684 7 16.3466 7 16V5Z"
    />
  </svg>
);

const BookmarkAltIcon = (props) => <Icon component={SVG} {...props} />;

export default BookmarkAltIcon;
